// import React, { useState, useEffect, useRef } from "react";
// import Pagination from "./Pagination";
// import "../assets/css/table.css";

// const Table = ({
//   columns,
//   data = [],
//   title,
//   currentPage,
//   totalCount,
//   pageSize,
//   onPageChange,
//   onPageSizeChange,
//   isLoading,
// }) => {
//   // ... (State and Filter/Sort Logic remains unchanged) ...
//   const [activeMenuColumn, setActiveMenuColumn] = useState(null);
//   const [showFilterInput, setShowFilterInput] = useState(null);
//   const [showMobileSearch, setShowMobileSearch] = useState(false);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [filters, setFilters] = useState({});
//   const menuRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setActiveMenuColumn(null);
//         setShowFilterInput(null);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const safeData = Array.isArray(data) ? data : [];

//   const filteredData = safeData.filter((item) => {
//     return Object.keys(filters).every((key) => {
//       if (!filters[key]) return true;

//       const val = item[key];
//       if (val === null || typeof val === "object") return true;

//       return String(val).toLowerCase().includes(filters[key].toLowerCase());
//     });
//   });

//   const sortedData = Array.isArray(filteredData)
//     ? [...filteredData].sort((a, b) => {
//         if (!sortConfig.key) return 0;

//         const aValue = a?.[sortConfig.key] ?? "";
//         const bValue = b?.[sortConfig.key] ?? "";

//         if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
//         if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
//         return 0;
//       })
//     : [];

//   const currentItems = sortedData;

//   // Mobile Sort Logic
//   const mobileColumns = [...columns].sort((a, b) => {
//     const orderA = a.mobileOrder !== undefined ? a.mobileOrder : 100;
//     const orderB = b.mobileOrder !== undefined ? b.mobileOrder : 100;
//     return orderA - orderB;
//   });

//   return (
//     <div
//       className="master-container"
//       style={{ minHeight: "auto", padding: "0", background: "transparent" }}
//     >
//       {/* Mobile Header */}
//       <div className="d-md-none mb-3">
//         <div className="d-flex justify-content-between align-items-center">
//           <span className="text-muted small">
//             Showing: <span className="fw-bold text-dark">{title}</span>
//           </span>
//           <button
//             className={`btn btn-md ${showMobileSearch ? "btn-light text-purple" : "btn-light text-purple"}`}
//             onClick={() => setShowMobileSearch(!showMobileSearch)}
//           >
//             <i
//               className={`bi ${showMobileSearch ? "bi-x-lg" : "bi-funnel-fill"} fs-6`}
//             ></i>{" "}
//             Filter
//           </button>
//         </div>
//         {showMobileSearch && (
//           <div className="mobile-search-box mt-3 p-3 bg-white rounded shadow-sm border">
//             <div className="row g-2">
//               {columns.map(
//                 (col, index) =>
//                   col.accessor && (
//                     <div className="col-6" key={index}>
//                       <label className="form-label small text-muted mb-1">
//                         {col.header}
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         placeholder="..."
//                         value={filters[col.accessor] || ""}
//                         onChange={(e) =>
//                           setFilters({
//                             ...filters,
//                             [col.accessor]: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   ),
//               )}
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Desktop Table */}
//       <div className="table-responsive d-none d-md-block custom-table-wrapper">
//         <table className="table align-middle">
//           <thead>
//             <tr>
//               {columns.map((col, index) => (
//                 <th
//                   key={index}
//                   className={col.className || ""}
//                   style={col.style}
//                 >
//                   <div className="th-content">
//                     <div className="d-flex align-items-center gap-1">
//                       {col.header}
//                       {col.accessor && sortConfig.key === col.accessor && (
//                         <i
//                           className={`bi bi-arrow-${sortConfig.direction === "asc" ? "up" : "down"} text-purple small`}
//                         ></i>
//                       )}
//                       {col.accessor && filters[col.accessor] && (
//                         <i className="bi bi-funnel-fill text-warning small"></i>
//                       )}
//                     </div>
//                     {col.accessor && (
//                       <button
//                         className={`header-menu-btn ${activeMenuColumn === col.accessor ? "active" : ""}`}
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setActiveMenuColumn(
//                             activeMenuColumn === col.accessor
//                               ? null
//                               : col.accessor,
//                           );
//                           setShowFilterInput(null);
//                         }}
//                       >
//                         <i className="bi bi-three-dots-vertical"></i>
//                       </button>
//                     )}
//                     {activeMenuColumn === col.accessor && (
//                       <div
//                         className="header-dropdown"
//                         ref={menuRef}
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         <div
//                           className="dropdown-item-custom"
//                           onClick={() => {
//                             setSortConfig({
//                               key: col.accessor,
//                               direction: "asc",
//                             });
//                             setActiveMenuColumn(null);
//                           }}
//                         >
//                           Sort Asc
//                         </div>
//                         <div
//                           className="dropdown-item-custom"
//                           onClick={() => {
//                             setSortConfig({
//                               key: col.accessor,
//                               direction: "desc",
//                             });
//                             setActiveMenuColumn(null);
//                           }}
//                         >
//                           Sort Desc
//                         </div>
//                         <div className="dropdown-divider"></div>
//                         <div
//                           className="dropdown-item-custom"
//                           onClick={() =>
//                             setShowFilterInput(
//                               showFilterInput === col.accessor
//                                 ? null
//                                 : col.accessor,
//                             )
//                           }
//                         >
//                           Filter
//                         </div>
//                         {showFilterInput === col.accessor && (
//                           <div className="menu-filter-box">
//                             <input
//                               type="text"
//                               className="menu-filter-input"
//                               placeholder="Search..."
//                               value={filters[col.accessor] || ""}
//                               onChange={(e) =>
//                                 setFilters({
//                                   ...filters,
//                                   [col.accessor]: e.target.value,
//                                 })
//                               }
//                               autoFocus
//                             />
//                           </div>
//                         )}
//                         <div className="dropdown-divider"></div>
//                         <div
//                           className="dropdown-item-custom"
//                           onClick={() => {
//                             setFilters({ ...filters, [col.accessor]: "" });
//                             setActiveMenuColumn(null);
//                           }}
//                         >
//                           Clear
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 </th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {currentItems.map((row, rowIndex) => (
//               <tr key={rowIndex}>
//                 {columns.map((col, colIndex) => (
//                   <td
//                     key={colIndex}
//                     className={col.className || ""}
//                     style={col.style}
//                     onClick={() => col.onCellClick && col.onCellClick(row)}
//                   >
//                     {col.render ? col.render(row) : row[col.accessor]}
//                   </td>
//                 ))}
//               </tr>
//             ))}
//             {currentItems?.length === 0 && (
//               <tr>
//                 <td colSpan={columns?.length} className="text-center py-4">
//                   No Data Found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* --- MOBILE CARD VIEW (Uses mobileColumns) --- */}
//       <div className="d-md-none">
//         {currentItems.map((row, i) => (
//           <div className="mobile-offer-card" key={i}>
//             {mobileColumns.map((col, idx) => {
//               // FULL WIDTH LOGIC (For Description OR Action Button)
//               if (col.mobileFullWidth) {
//                 return (
//                   <div key={idx} className="py-2 border-bottom border-light">
//                     {/* Using col.className allows passing 'text-center' from parent */}
//                     <div
//                       className={`text-dark small fw-bold mt-1 ${col.className ? col.className : "text-start"}`}
//                     >
//                       {col.render ? col.render(row) : row[col.accessor]}
//                     </div>
//                   </div>
//                 );
//               }

//               // Standard Layout
//               return (
//                 <div
//                   className="d-flex justify-content-between py-2 border-bottom border-light"
//                   key={idx}
//                 >
//                   <span className="text-muted small fw-bold">{col.header}</span>
//                   <span
//                     className="text-dark small fw-bold text-end"
//                     style={{ maxWidth: "60%" }}
//                   >
//                     {col.render ? col.render(row) : row[col.accessor]}
//                   </span>
//                 </div>
//               );
//             })}
//           </div>
//         ))}
//         {currentItems?.length === 0 && (
//           <div className="text-center text-muted py-5">No records found.</div>
//         )}
//       </div>

//       <div className="mt-3">
//         <Pagination
//           currentPage={currentPage}
//           totalCount={totalCount}
//           pageSize={pageSize}
//           onPageChange={onPageChange}
//           onPageSizeChange={onPageSizeChange}
//           disabled={isLoading}
//         />
//       </div>
//     </div>
//   );
// };

// export default Table;




import React, { useState, useEffect, useRef } from "react";
import Pagination from "./Pagination";
import "../assets/css/table.css";

const Table = ({
  columns,
  data = [],
  title,  
  currentPage,
  totalCount,
  pageSize,
  onPageChange,
  onPageSizeChange,
  isLoading,
}) => {
  // ... (State and Filter/Sort Logic remains unchanged) ...
  const [activeMenuColumn, setActiveMenuColumn] = useState(null);
  const [showFilterInput, setShowFilterInput] = useState(null);
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [filters, setFilters] = useState({});
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setActiveMenuColumn(null);
        setShowFilterInput(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const safeData = Array.isArray(data) ? data : [];

  const filteredData = safeData.filter((item) => {
    return Object.keys(filters).every((key) => {
      if (!filters[key]) return true;

      const val = item[key];
      if (val === null || typeof val === "object") return true;

      return String(val).toLowerCase().includes(filters[key].toLowerCase());
    });
  });

  const sortedData = Array.isArray(filteredData)
    ? [...filteredData].sort((a, b) => {
        if (!sortConfig.key) return 0;

        const aValue = a?.[sortConfig.key] ?? "";
        const bValue = b?.[sortConfig.key] ?? "";

        if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      })
    : [];

  const currentItems = sortedData;

  // Mobile Sort Logic
  const mobileColumns = [...columns].sort((a, b) => {
    const orderA = a.mobileOrder !== undefined ? a.mobileOrder : 100;
    const orderB = b.mobileOrder !== undefined ? b.mobileOrder : 100;
    return orderA - orderB;
  });

  return (
    <div
      className="master-container"
      style={{ minHeight: "auto", padding: "0", background: "transparent" }}
    >
      {/* Mobile Header */}
      <div className="d-md-none mb-3">
        <div className="d-flex justify-content-between align-items-center">
          <span className="text-muted small">
            Showing: <span className="fw-bold text-dark">{title}</span>
          </span>
          <button
            className={`btn btn-md ${showMobileSearch ? "btn-light text-purple" : "btn-light text-purple"}`}
            onClick={() => setShowMobileSearch(!showMobileSearch)}
          >
            <i
              className={`bi ${showMobileSearch ? "bi-x-lg" : "bi-funnel-fill"} fs-6`}
            ></i>{" "}
            Filter
          </button>
        </div>
        {showMobileSearch && (
          <div className="mobile-search-box mt-3 p-3 bg-white rounded shadow-sm border">
            <div className="row g-2">
              {columns.map(
                (col, index) =>
                  col.accessor && (
                    <div className="col-6" key={index}>
                      <label className="form-label small text-muted mb-1">
                        {col.header}
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="..."
                        value={filters[col.accessor] || ""}
                        onChange={(e) =>
                          setFilters({
                            ...filters,
                            [col.accessor]: e.target.value,
                          })
                        }
                      />
                    </div>
                  ),
              )}
            </div>
          </div>
        )}
      </div>

      {/* Desktop Table */}
      <div className="table-responsive d-none d-md-block custom-table-wrapper">
        <table className="table align-middle">
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th
                  key={index}
                  className={col.className || ""}
                  style={col.style}
                >
                  <div className="th-content">
                    <div className="d-flex align-items-center gap-1">
                      {col.header}
                      {col.accessor && sortConfig.key === col.accessor && (
                        <i
                          className={`bi bi-arrow-${sortConfig.direction === "asc" ? "up" : "down"} text-purple small`}
                        ></i>
                      )}
                      {col.accessor && filters[col.accessor] && (
                        <i className="bi bi-funnel-fill text-warning small"></i>
                      )}
                    </div>
                    {col.accessor && (
                      <button
                        className={`header-menu-btn ${activeMenuColumn === col.accessor ? "active" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveMenuColumn(
                            activeMenuColumn === col.accessor
                              ? null
                              : col.accessor,
                          );
                          setShowFilterInput(null);
                        }}
                      >
                        <i className="bi bi-three-dots-vertical"></i>
                      </button>
                    )}
                    {activeMenuColumn === col.accessor && (
                      <div
                        className="header-dropdown"
                        ref={menuRef}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div
                          className="dropdown-item-custom"
                          onClick={() => {
                            setSortConfig({
                              key: col.accessor,
                              direction: "asc",
                            });
                            setActiveMenuColumn(null);
                          }}
                        >
                          Sort Asc
                        </div>
                        <div
                          className="dropdown-item-custom"
                          onClick={() => {
                            setSortConfig({
                              key: col.accessor,
                              direction: "desc",
                            });
                            setActiveMenuColumn(null);
                          }}
                        >
                          Sort Desc
                        </div>
                        <div className="dropdown-divider"></div>
                        <div
                          className="dropdown-item-custom"
                          onClick={() =>
                            setShowFilterInput(
                              showFilterInput === col.accessor
                                ? null
                                : col.accessor,
                            )
                          }
                        >
                          Filter
                        </div>
                        {showFilterInput === col.accessor && (
                          <div className="menu-filter-box">
                            <input
                              type="text"
                              className="menu-filter-input"
                              placeholder="Search..."
                              value={filters[col.accessor] || ""}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  [col.accessor]: e.target.value,
                                })
                              }
                              autoFocus
                            />
                          </div>
                        )}
                        <div className="dropdown-divider"></div>
                        <div
                          className="dropdown-item-custom"
                          onClick={() => {
                            setFilters({ ...filters, [col.accessor]: "" });
                            setActiveMenuColumn(null);
                          }}
                        >
                          Clear
                        </div>
                      </div>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentItems.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col, colIndex) => (
                  <td
                    key={colIndex}
                    className={col.className || ""}
                    style={col.style}
                    onClick={() => col.onCellClick && col.onCellClick(row)}
                  >
                    {col.render ? col.render(row) : row[col.accessor]}
                  </td>
                ))}
              </tr>
            ))}
            {currentItems?.length === 0 && (
              <tr>
                <td colSpan={columns?.length} className="text-center py-4">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* --- MOBILE CARD VIEW (Uses mobileColumns) --- */}
      <div className="d-md-none">
        {currentItems.map((row, i) => (
          <div className="mobile-offer-card" key={i}>
            {mobileColumns.map((col, idx) => {
              // --- CHANGED HERE: Added check for 'task-name-col' ---
              // This ensures Task Name takes full width and hides the Key Label
              if (col.mobileFullWidth || col.className?.includes("task-name-col")) {
                return (
                  <div key={idx} className="py-2 border-bottom border-light">
                    {/* Using col.className allows passing 'text-center' from parent */}
                    <div
                      className={`text-dark small fw-bold mt-1 ${col.className ? col.className : "text-start"}`}
                    >
                      {col.render ? col.render(row) : row[col.accessor]}
                    </div>
                  </div>
                );
              }

              // Standard Layout
              return (
                <div
                  className="d-flex justify-content-between py-2 border-bottom border-light"
                  key={idx}
                >
                  <span className="text-muted small fw-bold">{col.header}</span>
                  <span
                    className="text-dark small fw-bold text-end"
                    style={{ maxWidth: "60%" }}
                  >
                    {col.render ? col.render(row) : row[col.accessor]}
                  </span>
                </div>
              );
            })}
          </div>
        ))}
        {currentItems?.length === 0 && (
          <div className="text-center text-muted py-5">No records found.</div>
        )}
      </div>

      {/* <div className="mt-3">
        <Pagination
          currentPage={currentPage}
          totalCount={totalCount}
          pageSize={pageSize}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          disabled={isLoading}
        />
      </div> */}
      {currentPage !== undefined &&
 totalCount !== undefined &&
 pageSize !== undefined && (
  <div className="mt-3">
    <Pagination
      currentPage={currentPage}
      totalCount={totalCount}
      pageSize={pageSize}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      disabled={isLoading}
    />
  </div>
)}
    </div>
  );
};

export default Table;